import React, { memo, useMemo } from 'react'
import { Skeleton, Alert, Typography, Steps } from 'antd'
import { StepsContainer } from './styles'
import { HeaderTitle } from '../../../../views/order-execution-plan/styles'
import { classNames } from '../../../../lib/classNames/classNames'
import { StagePlanItem } from './stage-plan-item'
import { StagePlanItemI, StagePlanItemOrderI, StagePlanItemType } from '../model/types/types'

type ItemType = StagePlanItemOrderI | StagePlanItemI
interface StagePlanProps {
  className?: string
  items?: ItemType[]
  isLoading?: boolean
  error?: string
  emptyMessage?: string
  title?: string
  typeItem?: StagePlanItemType
  hideHeader?: boolean
}

const { Text } = Typography

const StagePlan: React.FC<StagePlanProps> = memo((props: StagePlanProps) => {
  const {
    className,
    items,
    isLoading,
    error,
    emptyMessage = 'План исполнения пуст',
    title = 'План исполнения',
    typeItem = 'default',
    hideHeader
  } = props

  if (isLoading) {
    return <Skeleton active/>
  }

  if (!isLoading && error) {
    return <Alert
      message='При загрузке произошла ошибка'
      description={error}
      type='error'
    />
  }

  if (!isLoading && !error && (!items || !items?.length)) {
    return <Text>{emptyMessage}</Text>
  }

  const current = useMemo(() => {
    return items?.findIndex(stageItem => stageItem?.date_start && !stageItem?.date_end) || 0
  }, [items])

  return (
    <StepsContainer className={classNames('', {}, [className])}>
      { !hideHeader && (<HeaderTitle>{title}</HeaderTitle>) }
      <Steps size='small' current={current} direction='vertical'>
        {
          items?.map((stageItem, index) => {
            return <Steps.Step
              key={`${stageItem?.code}${index}`}
              title={<StagePlanItem typeItem={typeItem} { ...stageItem }/>}
              status={stageItem?.status || ((index === current) ? 'process' : 'wait')}
            />
          })
        }
      </Steps>
    </StepsContainer>
  )
})

export default StagePlan
